import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { LocalStoreManager } from './local-store-manager.service';
import { Employee } from '../models/employee.model';
import { EmployeeId } from '../models/employeeId.model';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseService, ApiResult } from '../base.service';

@Injectable({
  providedIn: 'root',
})

export class EmployeeService
  extends BaseService {
  constructor(
    http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private localStorage: LocalStoreManager) {
    super(http, baseUrl);
  }

  private employeeUrl: string = 'api/employee';

  getData<ApiResult>(
    tableNumber: number,
    pageIndex: number,
    pageSize: number,
    sortColumn: string,
    sortOrder: string,
    filterColumn: string,
    filterQuery: string
  ): Observable<ApiResult> {
    var url = 'api/employee';
    var params = new HttpParams()
      .set("tableNumber", tableNumber.toString())
      .set("pageIndex", pageIndex.toString())
      .set("pageSize", pageSize.toString())
      .set("sortColumn", sortColumn)
      .set("sortOrder", sortOrder);

    if (filterQuery) {
      params = params
        .set("filterColumn", filterColumn)
        .set("filterQuery", filterQuery);
    }

    return this.http.get<ApiResult>(url, { params });
  }

  newEmployee(employee: Employee): Observable<EmployeeId> {
     return this.http.post<EmployeeId>(this.employeeUrl, employee).pipe()
  }

  updateEmployee(employee: Employee) {
    const updated = {
      ...employee,
      emplStart: employee.emplStart ? this.toIsoDateString(employee.emplStart) : null,
      emplEnd: employee.emplEnd ? this.toIsoDateString(employee.emplEnd) : null
    };
    return this.http.put(this.employeeUrl, updated, { responseType: 'text' })
      .pipe(
      )
  }

  toIsoDateString(date: any): string {
    const d = (date instanceof Date) ? date : new Date(date);
    return [
      d.getFullYear(),
      (d.getMonth() + 1).toString().padStart(2, '0'),
      d.getDate().toString().padStart(2, '0')
    ].join('-');  // returns "YYYY-MM-DD" as a local date string
  }

  checkEmployee(id) {
    let language = this.localStorage.getDataObject("language");
    let endpointUrl = `${this.employeeUrl}/${id}:${language}`;
    return this.http.get(endpointUrl, { responseType: 'text' })
      .pipe()
  }

  deleteEmployee(EmployeeId: string, DelType: number) {
    const params = {
      EmployeeId: EmployeeId,
      DelType: DelType
    };
    return this.http.delete<Employee>(this.employeeUrl, { params });
  }

  get<Employee>(id): Observable<Employee> {
    let siteName = this.localStorage.getDataObject("sitename");
    var url = "api/employee/" + id;
    return this.http.get<Employee>(url);
  }

  put<Employee>(item): Observable<Employee> {
    var url = "api/employee/" + item.id;
    return this.http.put<Employee>(url, item);
  }

  post<Employee>(item): Observable<Employee> {
    var url = "api/employee";
    return this.http.post<Employee>(url, item);
  }

  delete<Employee>(id): Observable<Employee> {
    var url = "api/employee/" + id;
    return this.http.delete<Employee>(url);
  }

}
